import { render, staticRenderFns } from "./NippouReviewComponent.vue?vue&type=template&id=10bb0ace&"
import script from "./NippouReviewComponent.vue?vue&type=script&lang=js&"
export * from "./NippouReviewComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports